module.exports = __webpack_public_path__ + "img/cv-template-2.9015c095.png";